/*
  Puts the email capture on the quiz result screen.

  coffee-quiz.js is a compiled bundle whose source is not in this repo, so this
  does not try to modify the quiz. It watches for the result screen the app
  renders, then appends the card that main-coffee-quiz.liquid put in a
  <template>. If the app's markup ever changes, nothing appears and the quiz is
  untouched: the failure mode is a missing card, never a broken quiz.

  The form is Shopify's own customer form, so a signup here creates a customer
  with marketing consent exactly like the footer signup does. It is submitted
  with fetch so the result screen survives; a normal submit would navigate away
  and the customer would lose the recommendation they just answered eight
  questions for.
*/
(function () {
  var config = window.SaltySailorQuiz || {};
  if (config.captureEnabled === false) return;

  var mount = document.getElementById('SaltySailorCoffeeQuiz');
  var template = document.getElementById('QuizCaptureTemplate');
  if (!mount || !template) return;

  // The app re-renders the result when someone retakes the quiz, so the card
  // has to be placed again rather than once.
  function place() {
    var result = mount.querySelector('.quiz-result');
    if (!result) return;
    if (result.querySelector('[data-quiz-capture]')) return;

    var card = template.content.firstElementChild.cloneNode(true);
    // The right-hand column holds the result's other sections. Falling back to
    // the result root keeps the card visible if that column ever goes away.
    var column = result.querySelector('.quiz-result-col') || result;
    column.appendChild(card);
    wire(card);
  }

  function wire(card) {
    var form = card.querySelector('form');
    var formWrap = card.querySelector('[data-capture-form]');
    var done = card.querySelector('[data-capture-done]');
    var error = card.querySelector('[data-capture-error]');
    var codeButton = card.querySelector('[data-capture-code]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('button[type=submit]');
      var label = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Signing you on...';
      }
      error.hidden = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          formWrap.hidden = true;
          done.hidden = false;
        })
        .catch(function () {
          error.hidden = false;
          if (button) {
            button.disabled = false;
            button.textContent = label;
          }
        });
    });

    if (codeButton) {
      codeButton.addEventListener('click', function () {
        var code = codeButton.textContent.trim();
        var restore = function () {
          window.setTimeout(function () { codeButton.textContent = code; }, 1500);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            codeButton.textContent = 'Copied';
            restore();
          }, function () { /* leave the code showing, it is selectable */ });
        }
      });
    }
  }

  var observer = new MutationObserver(place);
  observer.observe(mount, { childList: true, subtree: true });
  place();
})();
